import React, { useState, useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import ClientsContext from "../../context/clients/clientsContext";
import SubscriptionsPage from "../pages/Subscriptions";
import PropTypes from "prop-types";

const SubscriptionModal = ({ client }) => {
  const clientContext = useContext(ClientsContext);
  const { setCurrent } = clientContext;

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setCurrent(client);
    setShow(true);
  };

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Subscriptions
      </Button>

      <Modal show={show} onHide={handleClose} dialogClassName="modal-75w">
        <Modal.Header closeButton>
          <Modal.Title className="modalTitleCenter">
            <h3>{client.name} Subscriptions</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SubscriptionsPage />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

// const modalStyle = {

//   width: '75%',
//   height: '75%'
// };

SubscriptionModal.propTypes = {
  client: PropTypes.object.isRequired
};

export default SubscriptionModal;
